// src/frontend/js/modern/ui/sortable-handler.js

import { SortableLite } from '../lib/sortable-lite.js';
import { queueManager } from '../core/queue.js';
import { eventBus, EVENTS } from '../core/event-bus.js';

export class SortableHandler {
	constructor() {
		this._instances = new Map();
		this._boundEvents = [];
	}

	init() {
		this._initAllTables();

		const onContentUpdated = () => {
			this._initAllTables();
		};
		eventBus.on(EVENTS.CONTENT_UPDATED, onContentUpdated);
		this._boundEvents.push({ event: EVENTS.CONTENT_UPDATED, handler: onContentUpdated });
	}

	_initAllTables() {
		const tables = document.querySelectorAll(
			'table.wlfmc-wishlist-items-wrapper.sortable:not(.no-interactions)'
		);

		tables.forEach(table => {
			const tableId = table.dataset.id || table.dataset.token || 'default';

			if (this._instances.has(tableId)) {
				const existing = this._instances.get(tableId);
				if (existing.element === table) return;
				existing.destroy();
				this._instances.delete(tableId);
			}

			const inst = new SortableLite(table, {
				items: '.wlfmc-table-item[data-row-id]',
				handle: '.sortable-handle',
				placeholderClass: 'ui-sortable-placeholder',
				scrollSensitivity: 40,
				update: () => {
					this._handleSortUpdate(table);
				},
			});
			this._instances.set(tableId, inst);
		});
	}

	_handleSortUpdate(table) {
		const positions = [];
		table.querySelectorAll('[data-row-id]').forEach(row => {
			positions.push(row.dataset.rowId);
		});

		if (positions.length === 0) return;

		const nonce = table.dataset.nonce
			|| document.querySelector('#wlfmc-wishlist-form table.wlfmc-wishlist-table')?.dataset.nonce
			|| '';

		queueManager.addWithDeduplication('sort_items', {
			nonce: nonce,
			positions: positions,
			wishlist_token: table.dataset.token,
			page: table.dataset.page || '',
			per_page: table.dataset.perPage || table.dataset.per_page || '',
		}).catch(err => {
			console.warn('[SortableHandler] Sort failed:', err);
		});
	}

	reInit() {
		this._initAllTables();
	}

	destroy() {
		this._instances.forEach(inst => inst.destroy());
		this._instances.clear();
		this._boundEvents.forEach(({ event, handler }) => {
			eventBus.off(event, handler);
		});
		this._boundEvents = [];
	}}
